import { themeVars } from '@tundr/theme';
import { style } from '@vanilla-extract/css';

export const eurIconClass = style({
  fontSize: themeVars.font.size.textLg,
  fontWeight: themeVars.font.weight.regular,
  color: themeVars.colors.neutrals.black100,
  position: 'relative',
  top: 2,
});
